import { Address } from "models/Address/address.model";
import { alias, list, object, primitive, serializable } from "serializr";

export class EndMarketLocations {

    @serializable
    id?: number;

    @serializable
    quantity?: number;

    @serializable(alias('is_transported_by_air', primitive()))
    isTransportedByAir?: boolean = false;

    @serializable(object(Address))
    address?: Address;

    addressLabel?: string; 

}

export class FarmBoxCommodityDestribution {

    @serializable(alias('total_quantity', primitive()))
    totalQuantity?: number;

    @serializable(list(object(EndMarketLocations)))
    routes?: EndMarketLocations[] = [new EndMarketLocations()]; // For showing first index as default fields

}


